// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#f4f4f5","menuBg":"#006592","menuHover":"red","subMenuBg":"#1f2d3d","subMenuHover":"red","sideBarWidth":"230px"};